import React from "react";
import { Box, Typography } from "@material-ui/core";
import {
  CustomBadge,
  CustomButton,
  PaymentPlanSharedComponentSkeleton,
} from "../../../../../../../../Components";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { PaymentPlanSharedComponent } from "../";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

function PaymentPlanComponent({ setTabValue, paymentData, isLoadingPayment }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();

  return (
    <Box className={styles.wrapperPayment}>
      <Box className={styles.containerHeader}>
        {isLoadingPayment ? (
          <>
            <Box className={styles.containerLeftSide}>
              <Skeleton variant="text" width={98} height={45} />
              <Skeleton
                style={{ borderRadius: "16px" }}
                width="39px"
                height="45px"
                variant="text"
              />
            </Box>
            <Skeleton variant="text" width={53} height={45} />
          </>
        ) : (
          <>
            <Box className={styles.containerLeftSide}>
              <Typography className={styles.containerMainTitle}>
                {translate("Payment-plan")}
              </Typography>
              <CustomBadge
                label={`${paymentData?.totalCount} Payment plan`}
                SizeVariant={"large"}
                BackgroundColor={palette.utility["brand_50"]}
                BorderColor={palette.utility["brand_200"]}
                Color={palette.utility["brand_700"]}
              />
            </Box>
            {paymentData?.result?.length > 0 && (
              <CustomButton
                boxShadow="none"
                size="sm"
                variant="text"
                color="tertiaryGray"
                style={{ minWidth: "fit-content" }}
                onClick={() => {
                  setTabValue(8);
                }}
              >
                {translate("View-All")}
              </CustomButton>
            )}
          </>
        )}
      </Box>
      <Box className={styles.cardWrapper}>
        <Box className={styles.containerSections}>
          {isLoadingPayment ? (
            Array.from({ length: 2 })?.map((_, index) => (
              <PaymentPlanSharedComponentSkeleton key={index} />
            ))
          ) : (
            <>
              {paymentData &&
                paymentData?.result?.length > 0 &&
                paymentData?.result
                  ?.slice(0, 2)
                  ?.map((paymentItem) => (
                    <PaymentPlanSharedComponent
                      key={paymentItem?.id}
                      paymentItem={paymentItem}
                    />
                  ))}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
export default PaymentPlanComponent;
